import {
  FileText,
  FileSpreadsheet,
  Image as ImageIcon,
  File,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

const fileIcons: Record<string, LucideIcon> = {
  pdf: FileText,
  docx: FileText,
  xlsx: FileSpreadsheet,
  pptx: FileText,
  txt: FileText,
  image: ImageIcon,
};

const fileColors: Record<string, string> = {
  pdf: "bg-red-500/10 text-red-500",
  docx: "bg-blue-500/10 text-blue-500",
  xlsx: "bg-emerald-500/10 text-emerald-600",
  pptx: "bg-orange-500/10 text-orange-500",
  txt: "bg-gray-500/10 text-gray-500",
  image: "bg-purple-500/10 text-purple-500",
};

export function FileIcon({ type }: { type: string }) {
  const Icon = fileIcons[type] ?? File;
  const cls = fileColors[type] ?? "bg-card text-secondary";

  return (
    <div
      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${cls}`}
    >
      <Icon size={16} />
    </div>
  );
}
